(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fillQuote = () => {
      const query = new URLSearchParams(window.location.search);
      if (query.get('shipping_quote') !== '1') return;
      const clean = (name, max) => (query.get(name) || '').replace(/[\u0000-\u001f\u007f]/g, ' ').slice(0, max);
      const sku = clean('part', 100);
      const title = clean('item', 350);
      const reference = clean('reference', 80);
      const physical = clean('physical', 100);
      const path = clean('product', 400);
      if (!sku || !title || !/^\d+:\d+$/.test(reference)) return;
      document.querySelectorAll('[data-sac-quote-fields]').forEach((fields) => {
        const form = fields.closest('form');
        const body = form.querySelector('[data-sac-quote-message]');
        const zip = fields.querySelector('[data-sac-quote-zip]');
        const ref = fields.querySelector('[data-sac-quote-reference]');
        fields.hidden = false;
        zip.disabled = false;
        zip.required = true;
        ref.disabled = false;
        ref.value = [sku, reference, physical, title].filter(Boolean).join(' | ');
        if (body && !body.value.trim()) {
          const productUrl = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+(?:\?variant=\d+)?$/i.test(path) ? `${window.location.origin}${path}` : '';
          body.value = [body.dataset.sacQuoteTemplate, title, sku, reference, physical, productUrl].filter(Boolean).join('\n');
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillQuote, { once: true });
    else fillQuote();
    document.addEventListener('shopify:section:load', fillQuote);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
